export const ROUTER_STATE_KEY = 'router';
